import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b2bf05e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-share-view" }
const _hoisted_2 = { class: "nav-list" }
const _hoisted_3 = { class: "nav-list-item" }
const _hoisted_4 = { class: "nav-list-item" }
const _hoisted_5 = { class: "nav-list-item" }

import {computed, inject} from 'vue'
  import {useRouter} from 'vue-router'
  import {useStore} from 'vuex'

  import IconButton from '@/components/inputs/IconButton.vue'
  import ContentSection from '@/components/ContentSection.vue'

  import {t} from '@/lib/i18n.js'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ShareView',
  setup(__props) {

  const store = useStore()
  const router = useRouter()

  const bus = inject('bus')

  const titleText = computed(() => t(store, 'share.title'))
  const contentText = computed(() => t(store, 'share.content'))
  const againText = computed(() => t(store, 'share.actions.again'))
  const shareText = computed(() => t(store, 'share.actions.share'))
  const homeText = computed(() => t(store, 'share.other'))

  const replayClicked = () => {
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click back to start'
      }
    })

    router.push({name: 'active.listen'})
  }

  const homeClicked = () => {
    //router.push({name: 'active.splash'})
    router.push('listen-selection')
  }

  const shareClicked = function () {
    const socialTitle = computed(() => t(store, 'social.title'))
    const socialContent = computed(() => t(store, 'social.content'))

    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click share'
      }
    })

    bus.publish({
      event: 'SHARE',
      data: {
        title: socialTitle.value,
        text: socialContent.value,
        files: []
      }
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_unref(titleText)), 1),
    _createVNode(ContentSection, { class: "content" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(contentText)), 1)
      ]),
      _: 1
    }),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(IconButton, {
            name: "replay",
            priority: "secondary",
            onClick: replayClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(againText)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(IconButton, {
            name: "share",
            priority: "secondary",
            onClick: shareClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(shareText)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(IconButton, { onClick: homeClicked }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(homeText)), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})